'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ownerForm = require('./owner-form.html');

var _ownerForm2 = _interopRequireDefault(_ownerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _ownerForm2.default,
  bindings: {
    adverseEvent: '<',
    states: '<',
    locked: '<'
  },
  controller: function () {
    function OwnerFormComponent() {
      'ngInject';

      _classCallCheck(this, OwnerFormComponent);
    }

    _createClass(OwnerFormComponent, [{
      key: 'hasValidContact',
      value: function hasValidContact(adverseEvent) {
        var validVet = adverseEvent.VetPerson && adverseEvent.VetPerson.FirstName && adverseEvent.VetPerson.LastName && adverseEvent.VetPerson.OfficePhone;

        return validVet;
      }
    }]);

    return OwnerFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/owner-form/owner-form.component.js